import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

interface ResponsiveImageProps {
  src: string;
  alt: string;
  className?: string;
  onClick?: (event: any) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
}

const ResponsiveImage = ({
  src,
  alt,
  className,
  onClick,
}: ResponsiveImageProps) => {
  const srcSetValues = [
    "$rsp-pdp-port-320$ 320w",
    "$rsp-pdp-port-640$ 640w",
    "$rsp-pdp-port-640$ 1080w",
    "$rsp-pdp-port-1080$ 1440w",
  ];
  const generateSrcSetUrl = (rspValue: string) =>
    formatAmplienceImageURL(`${src}?${rspValue}`);

  return (
    <img
      className={className}
      alt={alt}
      src={formatAmplienceImageURL(src + "?$rsp-pdp-port-1080$")}
      srcSet={`\n${srcSetValues.map((v) => generateSrcSetUrl(v)).join(",\n")}`}
      sizes="(max-width: 767px) 100vw, (min-width: 768px) 50vw"
      onClick={onClick}
      role="presentation"
    />
  );
};

export default ResponsiveImage;
